import React from 'react';
import { curry } from 'lodash';
import { Mutation } from 'react-apollo';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getUnits } from 'utils/unit';
import { unitSelector } from 'redux/preferences/selectors';

import { NAME as CASE_DELAYS_QUERY_NAME } from 'compositions/CaseDetailOverviewPanel/withCaseDelays/caseDelaysQuery';
import { NAME as CASE_NOTIFICATIONS_QUERY_NAME } from 'compositions/CaseActivityPanel/NotificationHistory/withCaseNotificationHistory/caseEmailHistoryQuery';
import { CASE_DEALER_RESPONSES_QUERY_NAME } from 'compositions/CaseDealerSelectionPanel/withCaseDealerResponses';
import { NAME as CASE_REQUEST_LINES_QUERY_NAME } from 'compositions/CaseRequestsPanel/CaseRequestsPanelContext/withCaseRequestLines';
import { NAME as CASE_DATA_QUERY_NAME } from '../withCaseData/caseDataQuery';
import updateCaseStatusGQL from './updateCaseStatusMutation';

const buildUpdateMutationChild = curry(
  (WrappedComponent, componentProps, mutate, { loading }) => {
    const updateCase = data =>
      mutate({
        ...data,
        variables: {
          ...(data || {}).variables,
          distanceUnit: getUnits(componentProps.unit).distanceUnitValue,
        },
      });

    return (
      <WrappedComponent
        {...componentProps}
        updateCaseStatus={updateCase}
        isUpdatingCaseStatus={!!loading}
      />
    );
  },
);

const withUpdateMutation = WrappedComponent => componentProps => (
  <Mutation
    mutation={updateCaseStatusGQL}
    refetchQueries={[
      CASE_DATA_QUERY_NAME,
      CASE_DELAYS_QUERY_NAME,
      CASE_NOTIFICATIONS_QUERY_NAME,
      CASE_REQUEST_LINES_QUERY_NAME,
      CASE_DEALER_RESPONSES_QUERY_NAME,
    ]}
  >
    {buildUpdateMutationChild(WrappedComponent, componentProps)}
  </Mutation>
);

const mapStateToProps = state => ({ unit: unitSelector(state) });

const withUpdateCaseStatus = WrappedComponent =>
  compose(
    connect(mapStateToProps),
    withUpdateMutation,
  )(WrappedComponent);

export default withUpdateCaseStatus;



// WEBPACK FOOTER //
// ./src/compositions/CaseStatus/withUpdateCaseStatus/index.js